import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { LoadingController, NavController, AlertController, NavParams, ModalController, ToastController } from '@ionic/angular';
import { trigger, style, animate, transition } from '@angular/animations';
import { PassaObjetoService } from '../../services/passa-objeto.service';
import * as moment from 'moment';
import { NavigationExtras } from '@angular/router';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/user/auth.service';
import { DadosService } from '../../services/dados/dados.service';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import {
  HttpClient,
  HttpEvent,
  HttpResponse,
  HttpHandler,
  HttpErrorResponse,
  HttpEventType,
  // tslint:disable-next-line: import-spacing
} from "@angular/common/http";

import jsPDF from 'jspdf';
import { flatten } from '@angular/compiler';


@Component({
  selector: 'app-novo-exame',
  templateUrl: './novo-exame.page.html',
  styleUrls: ['./novo-exame.page.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 }))
      ]),
      transition('* => void', [
        animate(500, style({ opacity: 0 }))
      ])
    ])

  ]
})



export class NovoExamePage implements OnInit {
  usuario: any;
  codUsuario: any;
  logado = false;
  exames: any;
  examesSpinner = true;
  historicoSpinner = false
  mostraCard = false;
  mostraCardContent = false;
  exameObj: any;
  examesUsuario: any;
  podePreencher = false
  podePreencherSpinner = true
  btSalvarAtivo = false
  formDataOut = new FormData();
  fileData = false;
  action = 'update';
  public loading: HTMLIonLoadingElement;
  form = {
    "dtexame": "",
    "cdmatricula": "",
    "codexame": "",
    "extensaoArquivo": ""
  }

  aPartirDoForm = false
  title = 'MPRJ - ComVocê';
  fileName: string;
  filePreview: string

  @ViewChild('fileInput', { static: false })
  fileInput: ElementRef;


  constructor(
    public loadingController: LoadingController,
    public navCtrl: NavController,
    //  public navParams: NavParams,
    public toastCtrl: ToastController,
    public modalController: ModalController,
    public alertController: AlertController,
    private dadosService: DadosService,
    private router: Router,
    private route: ActivatedRoute,
    private passaObjetoService: PassaObjetoService,
    private authService: AuthService,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,

  ) {

    let passaObj = this.passaObjetoService.getDestn()
    console.log(passaObj)
    if (passaObj && passaObj !== undefined) {
      this.aPartirDoForm = passaObj.aPartirDoForm
    } else {
      this.aPartirDoForm = false
    }
    console.log(this.aPartirDoForm)
    this.passaObjetoService.setDestn(null)
  }


  ngOnInit() {
    this.montaExameObj();
    this.pegaUsuario();
    this.route.queryParams.subscribe(params => {
      this.action = params['action'];
      if (this.action !== undefined) {
        if (this.action === 'update') {
          this.pegaUsuario();
        }
      }
    });
  }


  public uploadFile(event: { target: { files: any[]; }; }) {
    this.fileData = false
    this.form.extensaoArquivo = "PDF"
    let file = event.target.files[0]
    function isFileImage(file) {
      return file && file['type'].split('/')[0] === 'image';
    }
    if (file.size > 5000000) {
      this.fileInput.nativeElement.value = "";
      let message = "O arquivo teve ter, no máximo, 6MB de tamanho.  Por favor, reduza o tamanho deste ou selecione outro arquivo"
      let buttons = [{ text: 'Ok', role: 'cancel' }]
      this.chamaAlerta(message, buttons)
      return
    }
    if (isFileImage(file)) {
      let reader = new FileReader();
      if (event.target.files && event.target.files.length > 0) {
        let file = event.target.files[0];
        reader.readAsDataURL(file);
        reader.onload = () => {
          var doc = new jsPDF("p", "pt", "a4");
          var width = doc.internal.pageSize.getWidth() - 100;
          var height = doc.internal.pageSize.getHeight() - 200;
          this.resizeImage(reader.result, width, height).then(compressed => {
            let image = compressed['data']
            let w = compressed['iw']
            let h = compressed['ih']
            const marginX = (doc.internal.pageSize.getWidth() - w) / 2;
            const marginY = (doc.internal.pageSize.getHeight() - h) / 2;
            const base64ImgString = image.toString();
            doc.setFontSize(16);
            doc.text('MPRJ - ComVocê', 30, 30);
            doc.setFontSize(12);
            doc.text("EXAME - " + this.usuario.Nome + ' | ' + this.usuario.cdmatricula, 30, 50);
            doc.setFontSize(10);
            doc.text(this.usuario.email.toString(), 30, 70);
            doc.addImage(base64ImgString, 'JPEG', marginX, 100, w, h);
            var blob = new Blob([doc.output("blob")], { type: "application/pdf" });
            this.formDataOut.append("file", blob, "document.pdf");
            //  doc.save('exame-' + this.usuario.cdmatricula )
            this.fileData = true
          })
        };
      }
    } else {// fim isFileImage
      this.formDataOut.append("file", file, "document.pdf");
      this.fileData = true
    }
  }

  resizeImage(src, newX, newY) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        var iw = img.width;
        var ih = img.height;
        if (iw > ih) {
          if (iw > newX) {
            ih *= newX / iw;
            iw = newX;
          }
        } else {
          if (ih > newY) {
            iw *= newY / ih;
            ih = newY;
          }
        }
        const elem = document.createElement('canvas');
        elem.width = iw;
        elem.height = ih;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, iw, ih);
        const data = ctx.canvas.toDataURL()
        res({ data, iw, ih });
      }
      img.onerror = error => rej(error);
    })
  }
  pegaUsuario() {
    this.authService.usuario.subscribe(usr => {
      if (usr !== undefined && usr.toString() !== "UNAUTHORIZED") {
        this.logado = true
        this.usuario = usr
        console.log(this.usuario)
        if (this.aPartirDoForm === false) {
          this.pegaFormulariosUsuario(usr.cdmatricula)
          this.pegaExamesUsuario(usr.cdmatricula)
        } else {
          this.pegaExames()
          this.podePreencher = true
          this.podePreencherSpinner = false
        }
      }
    })
  }

  montaExameObj() {
    var dateMin = new Date();
    var monthMin = (dateMin.getMonth())
    var dayMin = (dateMin.getDate())
    var yearMin = (dateMin.getFullYear());
    var maxEventDate = new Date(yearMin, monthMin, dayMin).toISOString().substring(0, 10);
    var minEventDate = new Date(2020, 11, 1).toISOString().substring(0, 10);
    this.exameObj = {
      maxEventDate: maxEventDate,
      minEventDate: minEventDate,
      dtexame: maxEventDate,
      codexame: null,
      certificado: null,
    }
  }
  async presentToast(message, color, duration) {
    const toast = await this.toastCtrl.create({
      message,
      mode: 'ios',
      position: 'middle',
      color,
      duration,
    });
    toast.present();
  }
  doRefresh(event) {
    this.pegaExamesUsuario(this.usuario.cdmatricula)
    setTimeout(() => {
      event.target.complete();
    }, 1000);
  }

  pegaFormulariosUsuario(cdmatricula) {
    this.podePreencher = false
    this.podePreencherSpinner = true
    this.dadosService.listaFormUsuario(cdmatricula).subscribe(forms => {
      //  console.log("data", forms)
      //  forms = []
      if (forms.length > 0) {
        this.podePreencher = true
        this.podePreencherSpinner = false
        this.pegaExames()
      } else {
        this.podePreencher = false
        this.podePreencherSpinner = false
      }
    },
      error => {
        console.log("error", error)
        this.podePreencher = false
        this.podePreencherSpinner = false
      },
      () => {
        //this gets called on completion, callback code comes here
        console.log()
      });
  }


  pegaExamesUsuario(cdmatricula) {
    this.historicoSpinner = true
    this.dadosService.getExamesUsuario(cdmatricula).subscribe(exmUsr => {
      // console.log(exmUsr)
      this.historicoSpinner = false
      return this.examesUsuario = this.sortArray(exmUsr)
    });
  }
  sortArray(arr) {
    function compare(a, b) {
      // console.log(arr, a, b, Date.parse(a.dtexame), Date.parse(b.dtexame))
      if (Date.parse(a.dtexame) < Date.parse(b.dtexame)) {
        return 1;
      }
      if (Date.parse(a.dtexame) > Date.parse(b.dtexame)) {
        return -1;
      }
      return 0;
    }
    return arr.sort(compare);
  }
  async chamaAlerta(message, buttons) {
    const alert = await this.alertCtrl.create({
      message,
      buttons
    });
    await alert.present();
  }

  toggleNovoExame() {
    this.mostraCardContent = !this.mostraCardContent
  }



  pegaExames() {
    this.examesSpinner = true
    this.dadosService.getExames().subscribe(exames => {
      // console.log(exames)

      this.exames = exames
      this.examesSpinner = false
      this.mostraCard = true;

    });
  }



  ativaSalvar() {
    this.btSalvarAtivo = true
  }

  async salvaExame(exameObj) {

    console.log(this.formDataOut)
    if (this.fileData === false) {
      let message = "Você deve selecionar um arquivo (imagem ou PDF) com a comprovação de seu exame."
      let buttons = [{ text: 'Ok', role: 'cancel' }]
      this.chamaAlerta(message, buttons)
      return
    }

    this.loading = await this.loadingCtrl.create();

    await this.loading.present();
    this.form = {
      codexame: exameObj.codexame,
      cdmatricula: this.usuario.cdmatricula,
      dtexame: exameObj.dtexame,
      extensaoArquivo: this.form.extensaoArquivo,
    }
    // console.log(this.form)
    this.formDataOut.append("form", JSON.stringify(this.form));
    //  this.formDataOut.append("file", this.fileData);

    if (this.aPartirDoForm == false) { // se for para preencher pela tela de exames
      this.dadosService.salvaExameUser(this.formDataOut)
        .subscribe((event) => {
          this.formDataOut.delete("file");
          this.formDataOut.delete("form");
          this.fileData = null
          this.montaExameObj();
          if (event['cod'] == 200) {
            this.loading.dismiss().then(() => {
              this.btSalvarAtivo = false
              this.pegaExamesUsuario(this.usuario.cdmatricula)
              this.mostraCardContent = false


              let message = "Exame salvo com sucesso!"
              this.presentToast(message, 'success', 2000)
            });
          }
          if (event['cod'] == 500) {
            this.loading.dismiss().then(() => {
              let message = "Falha na execução. Confira os dados e tente novamente em alguns minutos."
              let buttons = [{ text: 'Ok', role: 'cancel' }]
              this.chamaAlerta(message, buttons)
            });
          }
        }
          ,
          err => {
            this.formDataOut.delete("file");
            this.formDataOut.delete("form");
            this.fileData = null
            this.montaExameObj();
            this.loading.dismiss()
            // console.log(err)
            if (err.statusText == "Unknown Error") {
              let message = "Falha na execução. Confira os dados e tente novamente em alguns minutos."
              let buttons = [{ text: 'Ok', role: 'cancel' }]
              this.chamaAlerta(message, buttons)
            }
            if (err.status == 400) {
              let message = "Falha na execução. Confira os dados e tente novamente em alguns minutos."
              let buttons = [{ text: 'Ok', role: 'cancel' }]
              this.chamaAlerta(message, buttons)
            }
            if (err.status == 500) {
              let message = "O arquivo excedeu o tamanho máximo permitido (6MB). Reduza o tamanho da imagem e tente novamente."
              let buttons = [{ text: 'Ok', role: 'cancel' }]
              this.chamaAlerta(message, buttons)
            }

          },
          () => console.log('ok')
        );
    } else {   // se for para preencher pela tela de formulário - devolve o objeto
      this.loading.dismiss()
      let tipoExame
      this.exames.forEach(exm => {
     //   console.log(exm)
        if(exm.codexame == this.form.codexame){
          console.log(exm.exame)
          tipoExame = exm.exame
        }
        
      });

      this.modalController.dismiss({ formExame: this.formDataOut, dtExame: this.exameObj.dtexame, tipoExame });
    }

  }
  verDetalhes(exame, exames) {
    this.passaObjetoService.navParams = { exame: exame, cdmatricula: this.usuario.cdmatricula, exames: exames }
    this.router.navigateByUrl('/exame-detalhes');
  }
  fechar() {
    this.modalController.dismiss();
  }
}
